import React from "react";
import { Reveal } from "../hooks/useReveal";
import { steps } from "../data/siteContent";

const HowItWorks = () => {
  return (
    <section className="bg-parchment py-24 sm:py-36" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="flex items-center gap-3 text-[11px] sm:text-xs tracking-[0.3em] uppercase font-semibold text-gold">
            <span className="h-px w-10 bg-gold/60" />
            How It Works
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-ink tracking-tight leading-[1.06] mt-6">
            How It Works. <em className="text-goldeep italic">Simple as 1 2 3.</em>
          </h2>
        </Reveal>

        <div className="mt-16 sm:mt-24">
          {steps.map((step, idx) => (
            <Reveal key={step.number} delay={idx * 80}>
              <div
                className="group grid md:grid-cols-12 gap-4 md:gap-10 items-start border-t border-ink/12 py-10 sm:py-14 hover:bg-ink/[0.025] transition-colors duration-500 px-2 sm:px-4"
                data-testid={`step-card-${step.number}`}
              >
                <div className="md:col-span-2">
                  <span className="font-display text-5xl sm:text-7xl text-goldeep/25 leading-none group-hover:text-goldeep/60 transition-colors duration-500">
                    {step.number}
                  </span>
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-display text-xl sm:text-2xl text-ink leading-snug">
                    {step.title}
                  </h3>
                </div>
                <div className="md:col-span-6">
                  <p className="text-ink/70 leading-relaxed text-base sm:text-lg">{step.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-ink/12" />
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
